var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Heading = require("../../../Heading");
var _simpleMarkdown = _interopRequireDefault(require("simple-markdown"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports["default"] = Object.assign({}, _simpleMarkdown["default"].defaultRules.heading, {
  react: function react(node, output, state) {
    return (0, _jsxRuntime.jsx)(_Heading.Heading, {
      level: node.level,
      style: state.containerStyle,
      children: output(node.content, state)
    }, state.key);
  },
  match: _simpleMarkdown["default"].blockRegex(/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n *)*\n/)
});